import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CaregiverDashboard from './components/CaregiverDashboard';
import AITrainingStudio from './components/AITrainingStudio';
import SemanticTrainer from './components/SemanticTrainer';
import SystemMonitor from './components/SystemMonitor';
import VoiceManagerTab from './components/VoiceManagerTab';  // 🎙️ Gestione Voci Multi-voce
import { VoiceAssistantDemo } from './components/VoiceAssistantDisplay';  // 💖 Demo Animazione Vocale
import VoiceHeart from './components/VoiceHeart';  // ❤️ Cuore stile ChatGPT
import RicordiPage from './components/RicordiPage';  // 📸 Pagina Ricordi
import VoiceChatNew from './components/VoiceChatNew';  // 🎙️ Test Vocale Debug
import VoiceECuore from './components/VoiceECuore';  // 💖 Voice + Cuore v9
import ProfiloPage from './components/ProfiloPage';  // 👤 Pagina Profilo
import './App.css';
import Navbar from './components/Navbar';

function App() {
  return (
    <Router>
      <div className="App" style={{ paddingBottom: '90px' }}>
        <Navbar />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<CaregiverDashboard />} />
            <Route path="/training" element={<AITrainingStudio />} />
            <Route path="/semantic" element={<SemanticTrainer />} />
            <Route path="/monitor" element={<SystemMonitor />} />
            <Route path="/voices" element={<VoiceManagerTab />} />
            <Route path="/voice-demo" element={<VoiceAssistantDemo />} />
            <Route path="/heart" element={<VoiceHeart />} />
            <Route path="/ricordi" element={<RicordiPage />} />
            <Route path="/voice-new" element={<VoiceChatNew />} />
            <Route path="/voice-e-cuore" element={<VoiceECuore />} />
            <Route path="/profilo" element={<ProfiloPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
